import { rem } from 'polished'
import { useContext, useReducer } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'
import AboveCardCloseButton from '../Common/AboveCardCloseButton'
import { StyledModalBody } from 'LuxKit/Modal/ModalBody'
import { StyledModalFooter } from 'LuxKit/Modal/ModalFooter'
import { StyledModalHeader } from 'LuxKit/Modal/ModalHeader'
import { MODAL_HEADER_GRID_AREA, MODAL_BODY_GRID_AREA, MODAL_FOOTER_GRID_AREA } from 'LuxKit/Modal/ModalSheet'
import { LuxKitModalBehaviourStateContext, LuxKitModalBehaviourDispatchContext } from 'LuxKit/Modal/context/LuxKitModalBehaviourContexts'
import type { LuxKitModalBehaviourDispatchAction } from 'LuxKit/Modal/context/LuxKitModalBehaviourState'
import type LuxKitModalBehaviourState from 'LuxKit/Modal/context/LuxKitModalBehaviourState'
import { luxKitModalBehaviourStateReducer, MODAL_BEHAVIOUR_INITIAL_STATE } from 'LuxKit/Modal/context/LuxKitModalBehaviourState'

const DesktopTile = styled.div`
  position: relative;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  box-shadow: ${props => props.theme.shadow.bottom.medium};
  width: ${rem(700)};
  max-width: calc(100% - ${rem(32)});
  max-height: ${rem(350)};

  display: grid;
  grid-template-areas:
    '${MODAL_HEADER_GRID_AREA}'
    '${MODAL_BODY_GRID_AREA}'
    '${MODAL_FOOTER_GRID_AREA}';
  grid-template-rows:
    [first]
    min-content
    1fr
    min-content
    [last];
  grid-template-columns: [first] 1fr [last];

  > ${StyledModalHeader} {
    grid-area: ${MODAL_HEADER_GRID_AREA};
  }

  > ${StyledModalBody} {
    grid-area: ${MODAL_BODY_GRID_AREA};
  }

  > ${StyledModalFooter} {
    grid-area: ${MODAL_FOOTER_GRID_AREA};
  }
`

interface Props {}

function DesktopOfferMapCard({ children }: React.PropsWithChildren<Props>) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  const [state, dispatch] = useReducer<LuxKitModalBehaviourState, [LuxKitModalBehaviourDispatchAction]>(luxKitModalBehaviourStateReducer, MODAL_BEHAVIOUR_INITIAL_STATE)

  return (
    <DesktopTile>
      <AboveCardCloseButton onClick={onDeselectMapItem} />
      <LuxKitModalBehaviourStateContext.Provider value={state}>
        <LuxKitModalBehaviourDispatchContext.Provider value={dispatch}>
          {children}
        </LuxKitModalBehaviourDispatchContext.Provider>
      </LuxKitModalBehaviourStateContext.Provider>
    </DesktopTile>
  )
}

export default DesktopOfferMapCard
